import classNames from 'clsx'
import { bool, func, shape } from 'prop-types'

import { TENANT_COM } from 'shared/consts'
import noop from 'shared/utils/noop'
import IconNew from 'views/components/atoms/Icon/IconNew'
import TextWithIcon from 'views/components/molecules/TextWithIcon'
import { shouldRenderErxAnnouncement } from 'views/components/organisms/Menubar/ErxTooltip/helpers'
import OffCanvasItem from 'views/components/organisms/OffCanvas/OffCanvasItem'
import Device from 'views/components/utils/Device'
import Tenant from 'views/components/utils/Tenant'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'
import { isRedPointsActive } from 'views/utils/featureToggleUtils'
import { offCanvasCategory } from 'views/utils/propTypes'

const OffCanvasItemList = ({
  data,
  goNextHandler,
  showCategoryTitle,
  ghosts,
  publicRuntimeConfig: {
    pageProperties: { featureToggles },
  },
}) => {
  const liClassName = classNames({
    'o-Offcanvas__Item--indented': showCategoryTitle,
  })

  const redPointsToggleIsActive = isRedPointsActive(featureToggles)

  // this is needed since bully has different names for 'subcategories',
  // depending on the level of category you are querying :(
  const categories = data.subCategories || data.subcategories

  // Don't allow multiple announcements be rendered
  let isAnnouncementFound

  return (
    <ul className="a-list-reset">
      {showCategoryTitle && (
        <li>
          <OffCanvasItem href={data.canonicalUrl}>{data.name}</OffCanvasItem>
        </li>
      )}

      {categories.map(({ id, canonicalUrl, hasSubcategories, name }) => {
        if (!redPointsToggleIsActive && name === 'RedPoints') {
          return null
        }

        const hasErxAnnouncement =
          !isAnnouncementFound && shouldRenderErxAnnouncement(canonicalUrl)
        if (hasErxAnnouncement) {
          isAnnouncementFound = true
        }

        return (
          <li
            className={liClassName}
            key={id}
            data-clientside-hook={
              hasErxAnnouncement ? 'handle-erx-announcement' : null
            }
          >
            <OffCanvasItem
              id={id}
              href={canonicalUrl}
              hasSubcategories={hasSubcategories}
              goNextHandler={goNextHandler}
              ghost={ghosts}
            >
              {name}
              {hasErxAnnouncement && (
                <Device mobile tablet>
                  <Tenant tenant={TENANT_COM}>
                    {() => (
                      <div
                        className="u-color--blue"
                        data-clientside-hook="wrap-erx-announcement"
                      >
                        <TextWithIcon icon={<IconNew />}>
                          <div className="a-h4 u-font-weight--bold u-no-margin">
                            E-Rezept einlösen
                          </div>
                        </TextWithIcon>
                      </div>
                    )}
                  </Tenant>
                </Device>
              )}
            </OffCanvasItem>
          </li>
        )
      })}
    </ul>
  )
}

OffCanvasItemList.propTypes = {
  data: offCanvasCategory.isRequired,
  goNextHandler: func,
  showCategoryTitle: bool,
  ghosts: bool,
  publicRuntimeConfig: shape({}),
}

OffCanvasItemList.defaultProps = {
  goNextHandler: () => noop,
  showCategoryTitle: false,
  ghosts: false,
  publicRuntimeConfig: {},
}

export default withShopAndRuntimeConfig(OffCanvasItemList)
